
import React, { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";
import PredictionDetailsCard from "@/components/PredictionDetailsCard";
import { getGroupFromNumber, getAnimalInfo } from "@/utils/animalImages";

type PredictionCardProps = {
  prediction: string;
  type: "milhar" | "centena" | "grupo" | "duque" | "terno";
  showAnimal?: boolean;
};

const PredictionCard = ({ prediction, type, showAnimal = false }: PredictionCardProps) => {
  const [showDetails, setShowDetails] = useState(false);

  const animalInfo = getAnimalInfo(prediction, type);
  const group = getGroupFromNumber(prediction);

  return (
    <>
      <Card className="relative group hover:shadow-lg transition-all duration-300 border-2 hover:border-primary/20 mobile-card bg-gradient-to-br from-card via-card to-muted/20">
        <CardContent className="p-3 sm:p-4 flex flex-col items-center justify-center text-center h-full min-h-[140px] sm:min-h-[160px]">
          <div className="w-full flex flex-col items-center justify-center flex-1">
            <h3 
              className="mb-1 sm:mb-2 text-primary font-black"
              style={{ 
                fontFamily: 'Arial Black, Arial, sans-serif', 
                fontSize: '44px',
                lineHeight: '1.1',
                letterSpacing: '-0.02em'
              }}
            >
              {prediction}
            </h3>
            <p className="text-xs sm:text-sm font-medium text-muted-foreground uppercase tracking-wide mb-2">
              {type}
            </p>
            
            {showAnimal && (
              <div className="flex flex-col items-center gap-1 sm:gap-2 mb-2 sm:mb-3">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-yellow-300 border-2 border-black flex items-center justify-center text-lg sm:text-xl font-black shadow-lg">
                  {animalInfo.firstLetter}
                </div>
                <div className="text-center">
                  <p className="text-xs sm:text-sm font-medium">{animalInfo.name}</p>
                  {group && (
                    <p className="text-xs text-muted-foreground">Grupo {group}</p>
                  )}
                </div>
              </div>
            )}
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setShowDetails(true)}
            className="absolute top-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity h-6 w-6 p-0"
          >
            <Info className="h-3 w-3 sm:h-4 sm:w-4" />
          </Button>
        </CardContent>
      </Card>

      <PredictionDetailsCard
        open={showDetails}
        onClose={() => setShowDetails(false)}
        prediction={prediction}
        predictionType={type}
      />
    </>
  );
};

export default PredictionCard;
